import { Button } from "../ui/button";
import { Input } from "../ui/input";
import DateInput from "../DateInput";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Landmark } from "lucide-react";

export const VersamentoDialog = ({ open, onOpenChange, form, onFormChange, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm bg-card border-border">
      <DialogHeader>
        <DialogTitle className="text-foreground flex items-center gap-2">
          <Landmark className="h-5 w-5" style={{ color: '#b45309' }} />
          Versamento in Banca
        </DialogTitle>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label className="text-foreground/70">Data *</Label>
          <DateInput value={form.data} onChange={(v) => onFormChange({ ...form, data: v })} />
        </div>
        <div className="space-y-2">
          <Label className="text-foreground/70">Importo (€) *</Label>
          <Input
            type="number"
            step="0.01"
            min="0.01"
            value={form.importo}
            onChange={(e) => onFormChange({ ...form, importo: e.target.value })}
            placeholder="0.00"
            required
            className="bg-card border-border text-foreground"
            data-testid="versamento-importo"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-foreground/70">Note</Label>
          <Textarea
            value={form.note}
            onChange={(e) => onFormChange({ ...form, note: e.target.value })}
            placeholder="Es. versamento settimanale"
            className="bg-card border-border text-foreground"
            data-testid="versamento-note"
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="border-border text-foreground hover:bg-accent hover:text-accent-foreground">Annulla</Button>
          <Button type="submit" style={{ backgroundColor: '#b45309', color: '#fff' }} data-testid="versamento-submit">Salva</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
